import { type JSX } from 'react';
import { IUIUrval } from '../../../../../../../Types/UrvalTypes';
import { getEmptyUrval } from '../../../../../../../Components/Urval/Utils/urvalUtils';
import { convertTEDUrvalToUIUrval } from '../../../../../../../Components/Urval/Utils/convertTEDUrvalToUIUrval';
import { ModelContextConsumer } from '../../../../../../../Model/ModelContext/ModelContext';
import {
  EkonomiskAnalysRadBaseradUrvalQuery as IData,
  EkonomiskAnalysRadBaseradUrvalQueryVariables as IVariables,
  EkonomiskAnalysRadBaseradUrvalQuery_node_TEDSelection,
} from './_QueryTypes/EkonomiskAnalysRadBaseradUrvalQuery';
import { Query } from '@apollo/client/react/components';
import query from './EkonomiskAnalysRadBaseradUrvalQuery.gql';
import Logger from '../../../../../../../Utils/Logger';

interface IProps {
  urvalId: string;
  children: (urval: IUIUrval) => JSX.Element;
}

const EkonomiskAnalysRadBaseradUrvalQuery = (props: IProps) => {
  return (
    <ModelContextConsumer>
      {({ avenyCollectionMap }) => (
        <Query<IData, IVariables>
          query={query}
          variables={{
            id: props.urvalId,
          }}
        >
          {({ loading, error, data }) => {
            if (loading) {
              return null;
            } else if (error) {
              Logger.error(error);
              return null;
            } else if (data === undefined || data.node === null) {
              return props.children(getEmptyUrval());
            } else {
              const node =
                data.node as EkonomiskAnalysRadBaseradUrvalQuery_node_TEDSelection;
              const urval = convertTEDUrvalToUIUrval(
                node.collection,
                JSON.parse(node.conditions || ''),
                avenyCollectionMap
              ).unsafelyUnwrap();

              return props.children(urval);
            }
          }}
        </Query>
      )}
    </ModelContextConsumer>
  );
};

export default EkonomiskAnalysRadBaseradUrvalQuery;
